/*::* INJECT CSS TO SHADOW DOM *::*/
document.addEventListener("DOMContentLoaded", () => {
  // const formContainer = document.querySelector('.form-container');

  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector("form-embed");

    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      const style = document.createElement("style");
      style.textContent = `
        *:is(h2._textHeading_2aowh_35, ._label_1wdej_10, ._textBody_2aowh_10, ._formDisclaimer_8skcf_38) {
          color: white !important;
        }

        #form-container-ref * {
          font-family: var(--font-body-family);
          font-size: var(--font-size-body);
          line-height: var(--line-height-body);
          font-weight: var(--font-weight-medium);
        }

        #form-container-ref ._inline_stahb_47 ._formContainer_stahb_30 {
          max-width: max(37.7777777778vw, 54.4rem);
        }

        #form-container-ref h2._textHeading_2aowh_35 {
          font-size: var(--font-size-h1);
          line-height: var(--line-height-h1);
          font-weight: var(--font-weight-bold);
          font-family: var(--font-header-family);
        }

        #form-container-ref ._formFieldset_8skcf_76 {
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: var(--spacing-sm);
          row-gap: var(--spacing-2sm);
        }

        #form-container-ref ._selectToggle_1wdej_25 {
          max-height: unset;
        }
        
        #form-container-ref ._formFieldset_8skcf_76 > *:is(:nth-last-child(1), :nth-last-child(2), :nth-last-child(3)) {
          grid-column: span 2;
        }

        #form-container-ref ._formDisclaimer_8skcf_38 > p {
          font-size: var(--font-size-description);
          line-height: var(--line-height-description);
        } 

        #form-container-ref  ._label_1wdej_10 {
          box-sizing: border-box;
          color: var(--color-black) !important;
          font-family: var(--font-body-family);
          font-size: var(--font-size-body);
          line-height: var(--line-height-body);
          font-weight: var(--font-weight-medium);
          margin-bottom: 0;
          height: 52px;
          display flex;
          align-items: center;
          margin-bottom: -52px;
          position: relative;
          z-index: 10;
          padding: var(--form-field-padding);
          pointer-events: none;
        }

        #form-container-ref button._selectToggle_1wdej_25[aria-controls='custom#how_can_we_help-selector-dropdown'] ._selectToggleText_1wdej_25 {
          background-color: var(--color-white);
          width: 100%;
          position: relative;
          z-index: 20;
        }

        #form-container-ref ._radioLegend_nw6va_18 {
          padding-bottom: var(--spacing-5xs);
        }

        #form-container-ref ._horizontalLayout_nw6va_12 {
          display: flex;
          gap: var(--spacing-2md);
        }

        #form-container-ref ._radioField_nw6va_1 {
          gap: var(--spacing-5xs);
        }

        #form-container-ref input._radioInput_nw6va_31[type="radio"] {
          -webkit-appearance: none;
          appearance: none;
          background-color: #fff;
          margin: 0;
          border-radius: 50%;
          overflow: hidden;
        }

        #form-container-ref ._radioInput_nw6va_31 {
          height: 1.6rem;
          --forms-accent-color: var(--color-black);
          --form-control-color: var(--color-black);
          display: grid;
          place-content: center;
        }

        #form-container-ref ._radioInput_nw6va_31::before {
          content: "";
          width: 0.8rem;
          aspect-ratio: 1;
          border-radius: 50%;
          transform: scale(0);
          transition: 120ms transform ease-in-out;
          box-shadow: inset 1em 1em var(--form-control-color);          
        }

        #form-container-ref ._radioInput_nw6va_31:checked::before {
          transform: scale(1);
        }

        #form-container-ref ._formSubmitButton_8skcf_90 {
          min-width: 13.3rem;
          width: fit-content;
          margin: 0 auto;
          background-color: var(--color-maroon);
          transition: var(--duration) var(--timing-function);
        }

        #form-container-ref  button._formSubmitButton_8skcf_90:focus-visible, 
        #form-container-ref  button._formSubmitButton_8skcf_90:hover {
          filter: unset;
          background-color: #856627;
        }

        #form-container-ref ._optionListItem_1wdej_102 > *,
        #form-container-ref ._optionListItem_1wdej_102 {
          height: auto;
          padding: 0;
          border-radius: 0 !important;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          background-color: transparent !important;
        }

        @media (max-width: 575px) {
          #form-container-ref ._formFieldset_8skcf_76 {
            grid-template-columns: 1fr;            
          }

          #form-container-ref ._formFieldset_8skcf_76 > *:is(:nth-last-child(1), :nth-last-child(2), :nth-last-child(3)) {
            grid-column: span 1;
          }

          #form-container-ref ._horizontalLayout_nw6va_12 {
            flex-direction: column;
            grid-gap: var(--spacing-xs);
          }
        }
      `;

      shadow.appendChild(style);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
